import {
    Accordion,
    AccordionSummary,
    CardContent,
    Typography,
} from '@mui/material';
import { FunctionComponent, PropsWithChildren, useState } from 'react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccordionDetails from '@mui/material/AccordionDetails';
import Alert from '@mui/material/Alert';
import { useFormErrorContext } from '@/context/FormErrorContext';

export const LiftOperatorFormCard: FunctionComponent<
    PropsWithChildren<{ title: string; groupName?: string }>
> = ({ title, groupName, children }) => {
    const [expanded, setExpanded] = useState(false);
    const [errors] = useFormErrorContext();
    return (
        <Accordion
            elevation={2}
            expanded={expanded}
            onChange={() => {
                setExpanded((prevState) => !prevState);
            }}
            sx={(theme) => ({
                borderRadius: theme.spacing(2),

                '&:before': {
                    display: 'none',
                },
            })}
        >
            <AccordionSummary
                expandIcon={
                    <ExpandMoreIcon
                        fontSize='medium'
                        sx={{
                            color: '#fff',
                        }}
                    />
                }
                sx={(theme) => ({
                    bgcolor: 'primary.light',
                    borderRadius: theme.spacing(2),
                    p: 4,
                    color: '#fff',
                    transition: theme.transitions.create(['background-color']),

                    '&:hover': {
                        bgcolor: 'primary.main',
                    },

                    ...(expanded && {
                        borderBottomRightRadius: 0,
                        borderBottomLeftRadius: 0,
                    }),
                })}
            >
                <Typography variant='h6'>{title}</Typography>
            </AccordionSummary>

            <AccordionDetails>
                {!!errors[groupName] && (
                    <Alert
                        sx={{
                            mt: 2,
                            mx: 2,
                        }}
                        variant='filled'
                        severity='error'
                    >
                        {errors[groupName]}
                    </Alert>
                )}

                <CardContent data-name={groupName}>{children}</CardContent>
            </AccordionDetails>
        </Accordion>
    );
};
